const filterListModalFilterEquip = {
  text: 'FILTROS',
  clear: 'borrar todos los filtros'
};

export default filterListModalFilterEquip;
